<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,2C15,2,6,2,6,2C5.72,2,5.47,2.11,5.29,2.29C5.29,2.29,0.29,7.29,0.29,7.29C0.11,7.47,0,7.72,0,8C0,8.280000000000001,0.11,8.530000000000001,0.29,8.71C0.29,8.71,5.29,13.71,5.29,13.71C5.47,13.89,5.72,14,6,14C6,14,15,14,15,14C15.55,14,16,13.55,16,13C16,13,16,3,16,3C16,2.45,15.55,2,15,2C15,2,15,2,15,2ZM12.71,9.29C12.89,9.469999999999999,13,9.719999999999999,13,10C13,10.55,12.55,11,12,11C11.72,11,11.47,10.89,11.29,10.71C11.29,10.71,10,9.41,10,9.41C10,9.41,8.71,10.7,8.71,10.7C8.53,10.89,8.28,11,8,11C7.45,11,7,10.55,7,10C7,9.719999999999999,7.11,9.469999999999999,7.29,9.29C7.29,9.29,8.59,8,8.59,8C8.59,8,7.29,6.71,7.29,6.71C7.11,6.53,7,6.28,7,6C7,5.45,7.45,5,8,5C8.28,5,8.53,5.109999999999999,8.71,5.29C8.71,5.29,10,6.59,10,6.59C10,6.59,11.29,5.3,11.29,5.3C11.47,5.109999999999999,11.72,5,12,5C12.55,5,13,5.45,13,6C13,6.28,12.89,6.53,12.71,6.71C12.71,6.71,11.41,8,11.41,8C11.41,8,12.71,9.29,12.71,9.29C12.71,9.29,12.71,9.29,12.71,9.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyBackspace',
} as DefineComponent
</script>
